import { ICustomTheme } from 'interfaces';
import styled from '@emotion/styled';

type Theme = {
  theme?: ICustomTheme;
};

export const Section = styled.div<Theme>({
  width: '100%',
  minHeight: 'inherit',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
});

export const DeclareButtonContainer = styled.div<Theme>(({ theme }) => ({
  margin: theme.spacing(3, 0),
}));
